export enum InterviewTemplateScope {
  Interview = 'interview',
  Questionnaire = 'questionnaire',
}
